import { Checkbox, Grid, styled } from "@mui/material";
import { ICardProperty } from "@rf-model/card-property.model";
import useShareProperty from "@rf/property/module/context/useShareProperty";

const PropertyCheckRefererOption = ({
  property,
  staticCheck
}: {
  property: ICardProperty;
  staticCheck?: boolean;
}) => {
  const { isChecked, addItem, removeItem } = useShareProperty();
  const checked = isChecked(property.id);

  const Cover = staticCheck ? StaticCheck : HoverCheck;
  return (
    <Cover className="checkbox-container">
      <Checkbox
        checked={checked}
        onChange={e => {
          if (e.target.checked) {
            addItem(property);
          } else {
            removeItem(property.id);
          }
        }}
      />
    </Cover>
  );
};
export default PropertyCheckRefererOption;

const HoverCheck = styled(Grid)(({ theme }) => ({
  width: 30,
  height: 30,
  transform: "translate(5px,10px)",
  borderRadius: 20,
  // ":hover": {
  //   background: "#FFF"
  // },
  "& .MuiButtonBase-root": {
    background: "#FFF",
    borderRadius: 20,
    padding: 2,
    transform: "translate(-0px,-6px)",
    display: "none"
  },
  "&:hover .MuiButtonBase-root": {
    display: "flex"
  },
  "& .MuiButtonBase-root.Mui-checked": {
    display: "flex"
  },
  "&:has(.Mui-checked)": {
    // background: "#FFF"
  }
}));
const StaticCheck = styled(Grid)(({ theme }) => ({
  background: "#FFF",
  borderRadius: 5,
  // padding: 0,
  ".MuiCheckbox-root": {
    padding: "1px 2px ",
    background: "#FFF",
    borderRadius: 5
    // margin: 0
  }
  // ":hover .MuiButtonBase-root": {
  //   display: "flex"
  // },
  // ":hover": {
  //   background: "#FFF"
  // },
  // "& .MuiButtonBase-root": {
  //   transform: "translate(-0px,-6px)",
  //   display: "none"
  // },
  // "& .MuiButtonBase-root.Mui-checked": {
  //   display: "flex"
  // },
  // "&:has(.Mui-checked)": {
  //   background: "#FFF"
  // }
}));
